import { GET_REPORT, GET_REPORT_SUCCESS, GET_REPORT_ERROR } from '../constants/ActionsTypes'

export const getReport = (params) => ({
  type: GET_REPORT,
  payload: params,
})

export const getReportSuccess = (data, reportId) => ({
  type: GET_REPORT_SUCCESS,
  payload: data,
  reportId,
})

export const getReportError = (error, reportId) => ({
  type: GET_REPORT_ERROR,
  payload: error,
  reportId,
})
